export const setStorageItems = (storage: Storage, values: { [key: string]: string }): void =>
  Object.entries(values).forEach(([key, value]) => storage.setItem(key, value));
